(function securityDataConfigDirectiveDefinition() {
    'use strict';

    angular.module('SecurityData', [])
        .directive('securityDataConfig', ['config',
            function securityDataConfigDirective(config) {
                return {
                    restrict: 'E',
                    templateUrl: config.resourceUrl('/directives/security-data-config/security-data-config.html'),
                    scope: {
                        selectedData: '=ngModel',
                        entityId: '=',
                        isContainerType: '=',
                        selectedItems: '=',
                        isDetail: '=',
                    },
                    controller: [
                        '$scope', '$element', '$attrs', '$uibModal', 'config', 'documentContainerService', 'containerTypeService', 'errorsExtend', 'storageService',
                        function collapsableMenuController($scope, $element, $attrs, $modal, config, documentContainerService, containerTypeService, errors, storageService) {
                            if (!$scope.containerDetail) {
                                $scope.containerDetail = 'simple';
                            }

                            $scope.search = function () {
                                var modalInstance = $modal.open({
                                    templateUrl: config.resourceUrl('/directives/security-data-config/security-data-config-modal.html'),
                                    controller: 'SecurityDataConfigModalController',
                                    size: 'lg',
                                    resolve: {
                                        entityId: function () {
                                            return $scope.entityId;
                                        },
                                        isContainerType: function () {
                                            return $scope.isContainerType;
                                        },
                                        selectedData: function () {
                                            return $scope.selectedItems;
                                        },
                                        isDetail: function () {
                                            return $scope.isDetail;
                                        }
                                    }
                                });

                                modalInstance.result.then(function (result) {
                                    if (result) {
                                        $scope.selectedData = result
                                    }
                                });
                            };

                        }
                    ]
                };

            }]);

})();